import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-left text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
      >
        <span className="flex items-center gap-2">
          <span className="flex h-5 w-5 items-center justify-center text-primary-600">
            <i className="ri-apps-2-line"></i>
          </span>
          {t('categories.dropdownLabel')}
        </span>
        <span className={`flex h-5 w-5 items-center justify-center text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line"></i>
        </span>
      </button>

      {open && (
        <div className="absolute left-0 top-full z-30 mt-2 max-h-80 w-full overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1">
          <p className="px-4 py-2 text-xs font-semibold uppercase tracking-wide text-foreground-400">
            {t('categories.dropdownHint')}
          </p>
          {categories.map((c) => (
            <a
              key={c.id}
              href={c.href}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-primary-100/60 hover:text-primary-800"
            >
              <span className="flex h-5 w-5 items-center justify-center text-secondary-600">
                <i className={c.icon}></i>
              </span>
              {t(c.nameKey)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}